import React, { PropsWithChildren } from 'react';
import { Divider, Popconfirm } from 'antd';
import Image from 'next/image';
import Bin from '../../public/icons/bin.svg';

type Props = {
  title?: string;
  onDelete?: () => void;
  className?: string;
};

export const ScreenQuestionCardLayout: React.FC<PropsWithChildren<Props>> = (props) => {
  const { title, onDelete, className, children } = props;

  return (
    <div
      className={`${className ?? ''} rounded-xl border border-[#F2F2f2] border-solid bg-white p-5`}>
      <div className="flex items-center justify-between px-3">
        <div className="text-base font-medium text-gray-700">{title ?? 'Custom Question'}</div>

        <Popconfirm
          title="Delete this item?"
          description="This action cannot be undone."
          okText="Delete"
          cancelText="Cancel"
          onConfirm={onDelete}
          okButtonProps={{ danger: true }}
          placement="left">
          <button
            type="button"
            className="cursor-pointer bg-white border-none"
            aria-label="Delete section">
            <Image src={Bin} alt="Delete" width={20} height={20} />
          </button>
        </Popconfirm>
      </div>

      <Divider className="my-3" />
      {children}
    </div>
  );
};
